import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

function LogoutIcon() {
  return (
    <svg viewBox="0 0 24 24">
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9" />
    </svg>
  );
}

export default function SidebarLogoutButton({ collapsed }) {
  const navigate = useNavigate();
  const { logout } = useAuth();

  return (
    <button
      type="button"
      className={`sidebar-item sidebar-logout-btn ${collapsed ? "collapsed" : ""}`.trim()}
      title={collapsed ? "Logout" : undefined}
      aria-label="Logout"
      onClick={() => {
        logout();
        navigate("/login", { replace: true });
      }}
    >
      <span className="sidebar-icon">
        <LogoutIcon />
      </span>
      <span className="sidebar-label">Logout</span>
    </button>
  );
}
